import React from 'react';

export default ({svg, onClick})=> (
	<span className='Icon' aria-hidden='true' dangerouslySetInnerHTML={{__html: svg}} onClick={onClick}/>
);